import { Box, Grid, Typography } from "@material-ui/core";
import React, { Fragment } from "react";
import { printDateTime } from "../lib/dateCalculate";
import { Phone } from "@material-ui/icons";

export default function HomeTicketList({ ticketList }) {
  return (
    <Box>
      <Grid container spacing={4} justifyContent="center">
        {ticketList.map((ticket, id) => (
          <Fragment key={id}>
            {!ticket.amountRefunded && (
              <Grid item md={6} sm={12} xs={12} lg={5}>
                <Grid
                  container
                  className="home-ticket-wrapper"
                  alignItems="center"
                >
                  {ticket.ticketNumber.startsWith("M") ? (
                    <Grid item md={4} sm={4} xs={4}>
                      <img
                        src={`/images/interview-image${
                          ticket.isFreeTicket ? `-free` : ""
                        }.png`}
                        alt=""
                        className="ticket-image"
                      />
                    </Grid>
                  ) : (
                    <Grid
                      item
                      md={4}
                      className="ticket-image-wrapper"
                      sm={4}
                      xs={4}
                    >
                      {ticket.staffImageUrl ? (
                        <img
                          src={ticket.staffImageUrl}
                          className="ticket-image"
                        />
                      ) : (
                        <img
                          src={"/images/staff_noimage.png"}
                          className="ticket-image"
                        />
                      )}
                      <div className="home-ticket-st">
                        <span>サポート形態</span>
                        <strong>
                          {ticket.supportType == "TEL"
                            ? "電話"
                            : ticket.supportType == "ONLINE" && "オンライン"}
                        </strong>
                      </div>
                    </Grid>
                  )}

                  <Grid
                    item
                    md={8}
                    sm={8}
                    xs={8}
                    className="home-ticket-details"
                  >
                    {ticket.reservationTime && (
                      <Typography
                        variant="h6"
                        component={"h6"}
                        className="bold-accent"
                      >
                        {printDateTime(ticket.reservationTime)}
                      </Typography>
                    )}
                    <Typography
                      component={"h5"}
                      variant={"h5"}
                      className="classification-heading"
                    >
                      {ticket.productName}
                    </Typography>
                    {ticket.interviewTelNumber && (
                      <Typography className="home-interview-number">
                        <img
                          src={"/images/phone-icon.png"}
                          alt=""
                          className="phone-icon"
                        />
                        {ticket.interviewTelNumber}
                      </Typography>
                    )}
                    <Typography
                      variant="h6"
                      component={"h6"}
                      className="bold-accent"
                    >
                      チケット番号: {ticket.ticketNumber}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Fragment>
        ))}
      </Grid>
    </Box>
  );
}
